import { render } from "./GroupReportTemplate.vue?vue&type=template&id=dc626c0e"
import script from "./GroupReportTemplate.vue?vue&type=script&lang=js"
export * from "./GroupReportTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__